import classes from "./about_the_robot.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRoute } from "@fortawesome/free-solid-svg-icons";
import { faLeaf } from "@fortawesome/free-solid-svg-icons";
import { faShieldHalved } from "@fortawesome/free-solid-svg-icons";
import { faTruckRampBox } from "@fortawesome/free-solid-svg-icons";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const AboutTheRobot = () => {
  const storedLang = localStorage.getItem("lang");
  let lng = storedLang ?? navigator.language;
  const { t, i18n } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage(lng);
  }, [lng, i18n]);

  return (
    <section className={classes["about-the-robot-section"]}>
      <div className={classes.container} id="autonomous-robot">
        <h4 className={classes.subtitle}>{t("about_the_robot.subtitle")}</h4>
        <h1 className={classes.title}>{t("about_the_robot.title")}</h1>
        <div className={classes.features}>
          <div className={classes.feature}>
            <div className={classes["icon-circle"]}>
              <FontAwesomeIcon
                className={classes["feature-icon"]}
                icon={faRoute}
              />
            </div>
            <h1 className={classes["feature-title"]}>
              {t("about_the_robot.safety")}
            </h1>
            <p className={classes["feature-description"]}>
              {t("about_the_robot.safety_description")}
            </p>
          </div>
          <div className={classes.feature}>
            <div className={classes["icon-circle"]}>
              <FontAwesomeIcon
                className={classes["feature-icon"]}
                icon={faLeaf}
              />
            </div>
            <h1 className={classes["feature-title"]}>
              {t("about_the_robot.battery")}
            </h1>
            <p className={classes["feature-description"]}>
              {t("about_the_robot.battery_description")}
            </p>
          </div>
          <div className={classes.feature}>
            <div className={classes["icon-circle"]}>
              <FontAwesomeIcon
                className={classes["feature-icon"]}
                icon={faShieldHalved}
              />
            </div>
            <h1 className={classes["feature-title"]}>
              {t("about_the_robot.secure")}
            </h1>
            <p className={classes["feature-description"]}>
              {t("about_the_robot.secure_description")}
            </p>
          </div>
          <div className={classes.feature}>
            <div className={classes["icon-circle"]}>
              <FontAwesomeIcon
                className={classes["feature-icon"]}
                icon={faTruckRampBox}
              />
            </div>
            <h1 className={classes["feature-title"]}>
              {t("about_the_robot.capacity")}
            </h1>
            <p className={classes["feature-description"]}>
              {t("about_the_robot.capacity_description")}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutTheRobot;
